import { callAPI } from '../network';

export async function getNewsLetterContentTypes (){
  
   const data = await callAPI(
                        null, 
                        'NewsLetterContentType', 'get');
   return data || [ ];
}
